import { IAppState } from '../../common/state';

export function isNewbuildingConsultantPopupOpen(state: IAppState) {
  return state.newbuildingConsultant.consultantPopupOpen;
}
